import { filter, pairwise, tap } from 'rxjs/operators';
import { BehaviorSubject, Unsubscribable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';

@Injectable()
export class RouterExitService {
  public previousUrl$ = new BehaviorSubject<any>(null);
  private routerSub: Unsubscribable;

  constructor(router: Router) {
    this.routerSub = router.events
      .pipe(
        filter(evt => evt instanceof RoutesRecognized),
        pairwise(),
      )
      .subscribe(([previous]: [RoutesRecognized, RoutesRecognized]) => {
        const [previousUrl] = previous.url.split('?');
        const { queryParams: previousQueryParams } = previous.state.root;
        this.previousUrl$.next({ url: previousUrl, queryParams: previousQueryParams });
      });
  }

  ngOnDestroy(): void {
    this.routerSub.unsubscribe();
  }
}
